export class CourseDetailDto {
  constructor(dto) {
    this.id = dto.id;
    this.name = dto.name;
    this.description = dto.description;
    this.code = dto.code;
    this.total_quizzes = dto.total_quizzes;
    this.ansi_approved = dto.ansi_approved;
    this.certificate_id = dto.certificate_id;
    this.active = dto.active;
    this.create_date = dto.create_date;
    this.edit_date = dto.edit_date;
  }
}
